module.exports = __webpack_public_path__ + "img/login-graphic01.87000244.png";